import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4 font-label">
            训练分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            选择你的训练方向
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            从基础激活到高阶强化，从居家训练到健身房方案，找到最适合你的蜜桃臀塑形路径
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center bg-background-50/90 rounded-full">
                    <i className={`${cat.icon} text-primary-600 text-sm`}></i>
                  </span>
                  <span className="text-background-50 font-semibold text-sm">{cat.name}</span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-foreground-600 text-xs leading-relaxed mb-3">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
                  <span className="text-primary-600 text-xs font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    查看全部
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}